import { Box, useTheme } from "@mui/material"

export const InvestigationItemContainer = ({ children, color, sx = {}, width = "100%" }) => {

  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'inline-grid',
        width,
        gridTemplateColumns: '5px auto',
        borderRadius: "5px",
        border: `1px solid ${theme.palette.blueGray200.main}`,
        borderLeft: 'none',
        overflow: 'hidden'
      } }
    >
      <Box
        sx={{
          backgroundColor: color ? color : theme.palette.ethicsBlue.main
        }}
      />

      <Box sx={{ ... sx }} >
        {children}
      </Box>

    </Box>
  )
}
